<script setup>
import CaseSliderSection from '@/components/sections/CaseSliderSection.vue'
import { ref, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getCases, getCasesCategory } from '@/api/cases.js'

const cases = ref([])
const caseCategories = ref([])

const route = useRoute()
const router = useRouter()

const activeCategorySlug = ref(route.query.category || null)

async function loadCases(categorySlug = null) {
	try {
		const [casesResponse, categoriesResponse] = await Promise.all([
			getCases(categorySlug),
			getCasesCategory(),
		])

		const rawCases = casesResponse.data
		const rawCategories = categoriesResponse.data

		caseCategories.value = processCaseCategories(rawCategories)
		cases.value = processCases(rawCases, rawCategories)
	} catch (error) {
		console.error('Ошибка загрузки данных', error.message)
		alert('Не удалось загрузить данные. Попробуйте позже.')
	}
}

function processCases(items, categories) {
	if (!Array.isArray(items)) return []
	return items.map((item) => {
		const category = categories.find((cat) => cat.id === item.category_id)
		return {
			id: item.id,
			title: item.heading,
			description: item.text,
			client: item.client,
			task: item.task,
			realized: item.realized,
			awards: item.awards,
			participants: item.participants,
			kpi: item.kpi,
			image_main: item.image_main,
			image_detail: item.image_detail,
			image_logo: item.image_logo,
			category: category?.slug || null,
		}
	})
}

function processCaseCategories(items) {
	if (!Array.isArray(items)) return []
	return items.map((item) => ({
		name: item.name,
		slug: item.slug || item.name.toLowerCase().replace(/\s+/g, '-'),
	}))
}

// Загружаем данные при монтировании с текущим фильтром из URL
onMounted(() => {
	loadCases(activeCategorySlug.value)
})

// При изменении фильтра в URL, меняем категорию и загружаем кейсы
watch(
	() => route.query.category,
	(newCategory) => {
		activeCategorySlug.value = newCategory || null
		loadCases(activeCategorySlug.value)
	},
)

// Функция для смены категории из дочернего компонента
function setActiveCategory(slug) {
	router.replace({
		query: {
			...route.query,
			category: slug,
		},
	})
}
</script>

<template>
	<CaseSliderSection
		:items="{ cases, categories: caseCategories }"
		:activeCategorySlug="activeCategorySlug"
		@change-category="setActiveCategory"
	/>
</template>
